import styled from "styled-components"

export const DropdownContent = styled.div`
  background: white;
  padding: 1rem;
  /* border: 20px solid green; */
`
